import { useParams } from "react-router-dom";
import FormPage from "../../components/forms/FormPage";
import useBibliographyController from "../../controllers/bibliographyController";
import FormTextField from "../../components/forms/fields/basic/TextField";
import FormSelectField from "../../components/forms/fields/basic/SelectField";
import { Bibliography } from "../../types/bibliography";

const AddEditBibliographyPage: React.FC = () => {
  const { _id = null } = useParams<{ _id?: string }>();
  const controller = useBibliographyController(_id);
  // Override title to use editTitle for form pages (includes "Edit/Create New" prefix)
  const formController = { ...controller, title: controller.editTitle };

  return (
    <FormPage<Bibliography> controller={formController}>
      <FormTextField
        name="filename"
        label="Filename"
        placeholder="Enter filename"
      />
      <FormTextField
        name="author"
        label="Author"
        placeholder="Enter author name"
      />
      <FormTextField
        name="title"
        label="Title"
        placeholder="Enter title"
      />
      <FormTextField
        name="volumes"
        label="Volumes"
        placeholder="Enter volumes"
      />
      <FormTextField
        name="year"
        label="Year"
        placeholder="Enter year"
      />
      <FormTextField
        name="sanskritof"
        label="Sanskrit Of"
        placeholder="Enter Sanskrit reference"
      />
      <FormTextField
        name="sans_complete"
        label="Sanskrit Complete"
        placeholder="Enter Sanskrit completeness"
      />
      <FormTextField
        name="sans_tohoku"
        label="Sanskrit Tohoku"
        placeholder="Enter Sanskrit Tohoku number"
      />
      <FormTextField
        name="sans_otani"
        label="Sanskrit Otani"
        placeholder="Enter Sanskrit Otani number"
      />
      <FormTextField
        name="tibetanof"
        label="Tibetan Of"
        placeholder="Enter Tibetan reference"
      />
      <FormTextField
        name="tibe_complete"
        label="Tibetan Complete"
        placeholder="Enter Tibetan completeness"
      />
      <FormTextField
        name="tibe_tohoku"
        label="Tibetan Tohoku"
        placeholder="Enter Tibetan Tohoku number"
      />
      <FormTextField
        name="tibe_otani"
        label="Tibetan Otani"
        placeholder="Enter Tibetan Otani number"
      />
      <FormTextField
        name="journal"
        label="Journal"
        placeholder="Enter journal name"
      />
      <FormTextField
        name="startpage"
        label="Start Page"
        placeholder="Enter start page"
      />
      <FormTextField
        name="endpage"
        label="End Page"
        placeholder="Enter end page"
      />
      <FormTextField
        name="booktitle"
        label="Book Title"
        placeholder="Enter book title"
      />
      <FormTextField
        name="bookeditor"
        label="Book Editor"
        placeholder="Enter book editor"
      />
      <FormTextField
        name="seriesname"
        label="Series Name"
        placeholder="Enter series name"
      />
      <FormTextField
        name="seriesnumber"
        label="Series Number"
        placeholder="Enter series number"
      />
      <FormTextField
        name="serieseditor"
        label="Series Editor"
        placeholder="Enter series editor"
      />
      <FormTextField
        name="publicationplace"
        label="Publication Place"
        placeholder="Enter publication place"
      />
      <FormTextField
        name="publisher"
        label="Publisher"
        placeholder="Enter publisher"
      />
      <FormTextField
        name="source"
        label="Source"
        placeholder="Enter source"
      />
      <FormSelectField
        name="jababo"
        label="JABABO"
        placeholder="Select JABABO"
        useEnum="ardi_jababo"
        selfFetching
      />
      <FormTextField
        name="no_of_volumes"
        label="Number of Volumes"
        placeholder="Enter number of volumes"
      />
      <FormTextField
        name="volume_no"
        label="Volume Number"
        placeholder="Enter volume number"
      />
      <FormTextField
        name="ardi_id"
        label="ARDI ID"
        placeholder="N/A"
        static
      />
      <FormTextField
        name="owner"
        label="Owner"
        placeholder="N/A"
        static
      />
    </FormPage>
  );
};

export default AddEditBibliographyPage;

